module.exports = __webpack_public_path__ + "img/10.e22ee5a2.jpg";